import React from "react";
import toast from "react-hot-toast";
import useApi from "../useApi";
import { GetAllAnalytics, GetAllAnalyticsRes } from "./index.type";

const useDashboardAnalytics = () => {
  const [analyticsData, setAnalyticsData] = React.useState<
    GetAllAnalytics | undefined
  >();

  const { loading: analyticsDataLoading, makeApiCall } = useApi({
    // url: `/RTM/patient-dashboard/analytics/${clinicId}/${associatedId}`,
    url:`/rtm/dashboard/analytics`,
    method: "GET",
  });

  const getDashboardAnalytics = async () => {
    const { response, error } = await makeApiCall<
      undefined,
      GetAllAnalyticsRes
    >();

    if (response?.status === "success") {
      setAnalyticsData(response.data);
    }

    if (!response?.status) {
      setAnalyticsData(undefined);
    }

    if (error) {
      toast.error(
        "Something went wrong while fetching analytics data. Please try again later"
      );
    }
  };

  return {
    analyticsData,
    getDashboardAnalytics,
    analyticsDataLoading,
  };
};

export default useDashboardAnalytics;
